import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent, ZoomMediaSelectedEvent } from '@theme/events';

function norm(s) {
  return (s || '').toString().trim().toLowerCase();
}

/**
 * Reads the currently selected color from the UI.
 * Works with button-style swatches (aria-pressed) + radio inputs.
 */
function getSelectedColorFromUI() {
  // Your theme uses button-like options (we saw aria-pressed in your UI)
  const pressed = document.querySelector('[aria-pressed="true"]');
  if (pressed && pressed.textContent) return pressed.textContent.trim();

  // Radio fallback
  const checkedRadio = document.querySelector('input[type="radio"]:checked');
  if (checkedRadio && checkedRadio.value) return checkedRadio.value.trim();

  // Last fallback: any selected/active class patterns
  const selected =
    document.querySelector('.is-selected') ||
    document.querySelector('.selected') ||
    document.querySelector('[data-selected="true"]');

  if (selected && selected.textContent) return selected.textContent.trim();

  return null;
}

/**
 * Filters gallery media based on ALT text stored in data-media-alt
 * Expect ALT like: "#Color_Black" "#Color_White" "#Color_Elmase"
 */
function filterGalleryMedia(_, colorValue) {
  if (!colorValue) return;

  const key = `#color_${norm(colorValue)}`;

  const mediaItems = document.querySelectorAll('.product-media[data-media-alt]');
  if (!mediaItems.length) return;

  mediaItems.forEach((media) => {
    const alt = norm(media.getAttribute('data-media-alt'));
    const matches = alt.includes(key);

    // Hide the image wrapper
    media.style.display = matches ? '' : 'none';

    // 🔥 CRITICAL: hide the gallery cell / slide / grid item
    const galleryItem =
      media.closest('.product-media-container') ||
      media.closest('li') ||
      media.closest('.media-gallery__item') ||
      media.parentElement;

    if (galleryItem && galleryItem !== media) {
      galleryItem.style.display = matches ? '' : 'none';
    }
  });
}



export class MediaGallery extends Component {
  connectedCallback() {
    super.connectedCallback();

    console.log('✅ MEDIA GALLERY CODE LOADED v1.3.0');

    const { signal } = this.#controller;
    const target = this.closest('.shopify-section, dialog');

    target?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate, { signal });
    this.refs.zoomDialogComponent?.addEventListener(ThemeEvents.zoomMediaSelected, this.#handleZoomMediaSelected, {
      signal,
    });

    // ✅ Filter on first load
    const color = getSelectedColorFromUI();
    console.log('initial color from UI:', color);
    filterGalleryMedia(this, color);
  }

  #controller = new AbortController();

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
  }

  #handleVariantUpdate = (event) => {
  const source = event.detail?.data?.html;
  if (!source) return;

  const newMediaGallery = source.querySelector('media-gallery');
  if (!newMediaGallery) return;

  const color = getSelectedColorFromUI();
  console.log('color from UI:', color);

  this.replaceWith(newMediaGallery);

  // ⏱️ Re-filter after DOM replacement
  setTimeout(() => filterGalleryMedia(document, color), 0);
};


  #handleZoomMediaSelected = async (event) => {
    this.slideshow?.select(event.detail.index, undefined, { animate: false });
  };

  zoom(index, event) {
    this.refs.zoomDialogComponent?.open(index, event);
  }

  get slideshow() {
    return this.refs.slideshow;
  }

  get media() {
    return this.refs.media;
  }

  get presentation() {
    return this.dataset.presentation;
  }
}

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', MediaGallery);
}
